import { Button } from "@tellescope/design-system";
import { PanelRightDashed } from "lucide-react";
import { useTranslation } from "react-i18next";
import { type TellescopeModelFromName } from "@tellescope/tanstack-query";

interface ActionsCellProps {
  enduser: Pick<TellescopeModelFromName<"endusers">, "id">;
  onSelectEnduser: (enduserId: string) => void;
}

export const ActionsCell = ({ enduser, onSelectEnduser }: ActionsCellProps) => {
  const { t } = useTranslation("contacts");

  return (
    <div className="flex items-center gap-1 justify-end">
      <Button
        iconOnly
        variant="ghost"
        size="sm"
        onClick={(e) => {
          e.stopPropagation();
          onSelectEnduser(enduser.id);
        }}
        hoverLabel={t("Open details panel")}
        data-trackingid="contacts-table-open-details-panel"
      >
        <PanelRightDashed />
      </Button>
    </div>
  );
};
